import React from "react";
import CommunitySection from './CommunitySection';


function getImgSrc(el, selector) {
  if (!el) {
    return '';
  }

  let child = el.querySelector(selector);
  return child && child.src ? child.src.trim() : '';
}

function getText(el, selector) {
  if (!el) {
    return '';
  }

  let child = el.querySelector(selector);
  return child ? child.textContent.trim() : '';
}

function getAll(el, selector) {
  if (!el) {
    return [];
  }
  return Array.from(el.querySelectorAll(selector));
}

export default class Community extends React.Component {
  render() {
    let config = this.props.config;

    let props = {
      title: getText(config, 'title'),
      action: {
        label: getText(config, 'action label'),
        href: getText(config, 'action href')
      },
      pages: getAll(config, 'page').map(page => {
        return {
          title: getText(page, 'title'),
          description: getText(page, 'description'),
          action: {
            label: getText(page, 'action label'),
            href: getText(page, 'action href')
          },
          pic: getImgSrc(page, 'img')
        };
      })
    };

    return (
      <CommunitySection {...props} />
    );
  }
}
